import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Slide } from "react-toastify";
import { useNavigate } from "react-router-dom";

const EducationYearCreate = () => {
  const [form, setForm] = useState({ title: "", time: "" });
  const navigate = useNavigate();

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

const handleSubmit = async e => {
  e.preventDefault();
  try {
    await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/education-years/create`,
      form,
      { headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` } }
    );

    toast.success(
      <div className="d-flex align-items-center gap-2">
        <span>Eğitim yılı başarıyla kaydedildi</span>
      </div>,
      { transition: Slide }
    );

    setTimeout(() => {
      navigate("/education-year/table");
    }, 1500);

  } catch (err) {
    console.error("❌ Oluşturma hatası:", err);
    toast.error(
      <div className="d-flex align-items-center gap-2">
        <img
          src="/images/error-icon.png"
          alt="error"
          style={{ width: 24, height: 24 }}
        />
        <span>Kaydetme başarısız oldu</span>
      </div>,
    );
  }
};

  return (
    <div className="container mt-4">
      <form className="card p-4" onSubmit={handleSubmit}>

        <div className="mb-3">
          <label className="form-label">Başlık</label>
          <input
            className="form-control"
            name="title"
            value={form.title}
            onChange={handleChange}
            placeholder="Başlığı girin"
            required
          />
        </div>

        <div className="d-flex justify-content-center">
          <button className="btn btn-primary">Kaydet</button>
        </div>
      </form>
    </div>
  );
};

export default EducationYearCreate;
